export default "__VITE_ASSET__DOcvJH1j__"